import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { JobService } from 'src/app/services/jobs/job.service';
import * as _ from 'lodash';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-add-mp-job',
  templateUrl: './add-mp-job.component.html',
  styleUrls: ['./add-mp-job.component.scss']
})
export class AddMpJobComponent implements OnInit {

  jobForm;
  placeholder = "Starting date"
  clients: any;
  selectedClient: any;
  selectedLocation: any;
  selectedClients: any = [];
  matcher = new MyErrorStateMatcher();
  color: any;
  rgba: any;
  always: any;
  isDisabled;
  loading: boolean;
  mps: any;
  trainerJobs: any;
  displayPlanner = false
  plannerData
  date
  isValidation
  selectedInstructors = []
  medicalPractioner
  medicalOptions = [
    "Medical",
    "Drugs",
    "Alcohol",
    "Uploaded To Sentinel"
  ]
  error: any;
  constructor(public _jobService: JobService, public _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, public _clientService: ClientService,
    public _staffService: StaffService, private router: Router, public formBuilder: FormBuilder, public _mpJobService: MpjobService) {

    this.activatedRoute.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        console.log("what is in state data", this.router.getCurrentNavigation().extras.state);
        if (this.router.getCurrentNavigation().extras.state.data) {
          this.displayPlanner = true
          this.plannerData = this.router.getCurrentNavigation().extras.state.data
        } else if (this.router.getCurrentNavigation().extras.state.instructor) {
          this.medicalPractioner = this.router.getCurrentNavigation().extras.state.instructor
          // this.selectedInstructors.push(tempData._id)
        }
      }
    });
  }

  ngOnInit() {
    this.getClients();
    this.getMps();
    this.getTrainerJob();

    if (this.displayPlanner) {
      this.jobForm = new FormGroup({
        title: new FormControl('', Validators.required),
        jobColor: new FormControl('', Validators.required),
        // client: new FormControl('', Validators.required),
        // location: new FormControl('', Validators.required),
        meds: new FormControl(this.selectedInstructors),
        clients: this.formBuilder.array([this.multipleClients()]),
        linkedJob: new FormControl(''),
        tracker: new FormControl('', Validators.required),
        startingDate: new FormControl(new Date(this.plannerData.date))
      })

      this.selectedInstructors.push(this.plannerData.selectedUser)
      this.jobForm.controls.meds.setValue(this.selectedInstructors);
    } else {
      this.jobForm = new FormGroup({
        title: new FormControl('', Validators.required),
        jobColor: new FormControl('', Validators.required),
        // client: new FormControl('', Validators.required),
        // location: new FormControl('', Validators.required),
        clients: this.formBuilder.array([this.multipleClients()]),
        meds: new FormControl(''),
        tracker: new FormControl('', Validators.required),
        linkedJob: new FormControl(''),
        startingDate: new FormControl('', Validators.required)
      })

    }
  }



  multipleClients() {
    return this.formBuilder.group({
      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    })
  }


  get multipleClientsGroup() { return <FormArray>this.jobForm.get('clients') }


  AddMultipleClients() {
    const control = <FormArray>this.jobForm.controls.clients

    control.push(this.formBuilder.group({

      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    }))

  }


  onChange(value) {

    this.jobForm.patchValue({ startingDate: value })
    console.log("event call sucessfully", this.jobForm.value)
  }


  deleteClient(data, i) {

    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.jobForm.controls.clients
    control.removeAt(i)
    let clientId = data.value.client._id
    let locationId = data.value.location
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })


    console.log("main index value", index);

    if (index > -1) {

      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == locationId })
      // console.log("whatt is the index 1 value", index1);
      delete this.clients[index].locations[index1]['added']
      // console.log("remaining client value", this.clients[index].locations[index1]);
      // console.log("value of selected client", this.selectedClient);

    }
  }



  addClientInClients(event, client) {

    console.group(" add client and location ", event)
    // console.log("what is the selected location dataa", this.selectedLocation);
    console.log("what is the total clienet array=====", this.clients);
    console.log("data of client already selected========", client);
    let clientId = client.value.client._id
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })

    if (index > -1) {

      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == event.value })
      console.log("whatt is the index 1 value", index1);

      // if (index1 > -1) {
      this.clients[index].locations[index1]['added'] = true
      // this.clients[index].locations.splice(index1, 1)
      // if (!this.clients[index].locations.length)
      //   this.clients.splice(index, 1)
      // this.selectedClient = null
      // }
      console.log("remaining client value", this.clients[index]);
      console.log("value of selected client", this.selectedClient);

    }
  }



  clientChanged(data) {
    this.selectedClient = data.value;
    console.log(this.selectedClient);
  }

  addJob() {
    console.log('this.addJObForm', this.jobForm)

    console.log('this.jobForm.controls.valid', this.jobForm.valid);

    if (this.jobForm.valid) {

      // this.jobForm.controls.client.setValue(this.selectedClient._id)

      let requestData = {
        jobColor: this.jobForm.value['jobColor'],
        linkedJob: this.jobForm.value['linkedJob'],
        meds: this.jobForm.value['meds'],
        startingDate: this.jobForm.value['startingDate'],
        title: this.jobForm.value['title'],
        clients: this.jobForm.value['clients'],
        tracker: this.jobForm.value['tracker']
      }
      this.error = ''
      console.log('this.addJObForm', this.jobForm.value);

      console.log(" Request data for add new job ", requestData)

      this._mpJobService.addJob(requestData).subscribe(res => {
        console.log("RESPONSE", res)
        this.router.navigateByUrl('/mpjob/' + res._id)
        // this.router.navigate(['/jobs']);
      }, err => {
        console.log('Error while Adding job:', err);
        this.loading = false;
      })
    }
    else {
      this.jobForm.markAllAsTouched()
      this.error = "All fields are required"
    }
  }

  getClients() {
    this._clientService.getClients().subscribe((clients) => {
      this.clients = clients;
    });
  }

  getMps() {
    console.log('Get Mps Function Calling:');
    this._staffService.getMps().subscribe(res => {
      this.mps = res;
      console.log("value of medicalPractioner", this.medicalPractioner);

      if (this.medicalPractioner != undefined) this.selectedInstructors.push(this.medicalPractioner._id)
      if (this.selectedInstructors && this.selectedInstructors.length) this.jobForm.controls.meds.setValue(this.selectedInstructors);

    })
  }

  instructorChanged(data) {
    console.log('Data ===>', data);
  }

  clearForm() {
    console.log("Clear Form Called");
    this.jobForm.reset();
    this.ngOnInit();
  }

  getTrainerJob() {
    console.log("Trainer Job List Here");

    this._jobService.getTrainerJob().subscribe((res => {
      console.log('Res here of traninig jobs', res);
      this.trainerJobs = res;
    }))
  }

  removeClientFormClients(index) {
    console.log(" check here index for remove from selection ", index)

    let clientCopy = this.selectedClients[index].client;
    let locationCopy = this.selectedClients[index].location;
    this.selectedClients.splice(index, 1)

    const foundClientIndex = _.findIndex(this.clients, function (o) { return o._id == clientCopy._id })

    if (foundClientIndex > -1) {
      // console.log(" Client Found ::: ", this.clients[foundClientIndex] ) 
      this.clients[foundClientIndex]['locations'].push(locationCopy)
    }
    else {
      console.log(" Client Not Found Add in clients array ")
      console.log(" Now add location in clients ")
      clientCopy['locations'] = []

      clientCopy['locations'].push(locationCopy)

      this.clients.push(clientCopy)

      this.selectedClient = null
      this.selectedLocation = null


    }



    console.log(" let clientCopy ", clientCopy)
    console.log(" let locationCopy ", locationCopy)

  }

  // addClientInClients() {

  //   console.group(" add client and location ")


  //   console.log(" this.selectedLocation ", this.selectedLocation)

  //   const selectedClientId = this.selectedClient._id
  //   const selectedLocationId = this.selectedLocation

  //   console.log(" selectedLocationId ", selectedLocationId)

  //   const foundLocation = _.findIndex(this.selectedClient['locations'], function (o) { return o._id == selectedLocationId })

  //   this.selectedClients.push({ client: this.selectedClient, location: this.selectedClient['locations'][foundLocation] })

  //   console.log(" this.selectedClients ", this.selectedClients)

  //   this.selectedClient = null

  //   const index = _.findIndex(this.clients, function (o) { return o._id == selectedClientId })

  //   if (index > -1) {

  //     const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == selectedLocationId })

  //     if (index1 > -1) {
  //       this.clients[index].locations.splice(index1, 1)

  //       if (!this.clients[index].locations.length) this.clients.splice(index, 1)

  //     }

  //   }
  // }


  medicalOptionChange(event) {
    console.log("event when select option for medical", event);

  }

}
